export default __webpack_public_path__ + "static/media/uploader-trivia-problem-1.3ed8b4b9.png";